import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { DropdownFrameComponent } from '../dropdown-frame/dropdown-frame.component';
import { DataService, FlagService } from '@core/services';
import { faInfoCircle, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { DecimalPipe } from '@angular/common';
import { PaymentFrequencyDto } from '../../../modules/_services/api/@generated/models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payfrequency-juncture',
  templateUrl: './payfrequency-juncture.component.html',
  styleUrls: ['./payfrequency-juncture.component.scss'],
  standalone: false
})
export class PayfrequencyJunctureComponent implements OnInit, AfterViewInit {
  faInfoCircle = faInfoCircle;
  faCalendar = faCalendar;

  //for data reusage in insurantData
  insurantData = this.DropdownFrame.returnInsurantData();

  mockedData = new Array;
  _feedbackLabel: String;

  constructor(private DropdownFrame: DropdownFrameComponent, public FlagService: FlagService,
              private decimalPipe: DecimalPipe,
              private translate: TranslateService,
              private dataService: DataService) { }

  @Output() newInsurantDataEvent = new EventEmitter<any>();
  @Output() newInsurantDataLocation = new EventEmitter<string>();

  ngAfterViewInit(): void {
    window.scrollTo(0, this.dataService.fixInfoContainerHeight + 335 + (this.dataService.isPartneri() ? 65 : 0) + (this.dataService.isKompakt() ? 0 : 60));
  }

  ngOnInit(): void {
    const contract: string = sessionStorage.getItem('HIPContract');
    const payFreqOptions: PaymentFrequencyDto = JSON.parse(contract).paymentFrequencyOptions;
    this.mockedData = [];

    if (payFreqOptions) {
      if (payFreqOptions.monthly && payFreqOptions.monthly === 1) {
        this.mockedData.push(
          {month: this.translate.instant('junctures.payFrequency.1h'), label: this.translate.instant('junctures.payFrequency.monthlyFee'), detail: 90900, value: '12', amount: this.insurantData.insuranceFee.monthlyFee}
        );
      }
      if (payFreqOptions.quarterly && payFreqOptions.quarterly === 1) {
        this.mockedData.push(
          {month: this.translate.instant('junctures.payFrequency.3h'), label: this.translate.instant('junctures.payFrequency.quarterlyFee'), detail: 90900, value: '4', amount: this.insurantData.insuranceFee.quarterlyFee}
        );
      }
      if (payFreqOptions.semiAnnually && payFreqOptions.semiAnnually === 1) {
        this.mockedData.push(
          {month: this.translate.instant('junctures.payFrequency.6h'), label: this.translate.instant('junctures.payFrequency.semiAnnualFee'), detail: 90900, value: '2', amount: this.insurantData.insuranceFee.semiAnnualFee}
        );
      }
      if (payFreqOptions.annually && payFreqOptions.annually === 1) {
        this.mockedData.push(
          {month: this.translate.instant('junctures.payFrequency.1y'), label: this.translate.instant('junctures.payFrequency.annualFee'), detail: 90900, value: '1', amount: this.insurantData.insuranceFee.annualFee}
        );
      }
    }

    if(this.insurantData.paymentFrequency) {
      for(let i in this.mockedData) {
        if(this.mockedData[i].value === this.insurantData.paymentFrequency) {
          this._feedbackLabel = this.mockedData[i].label + ' - '
            + this.decimalPipe.transform(this.mockedData[i].amount, '1.0-0', 'hu-HU') + ' Ft';
        }
      }
    }
  }

  sendUserdata(event: any) {
    let payFrequency = event.target.id;
    if (payFrequency === '') {
      payFrequency = event.target.closest('li').id;
    }

    for(let i in this.mockedData) {
      if(this.mockedData[i].value === payFrequency) {
        this._feedbackLabel = this.mockedData[i].label + ' - '
          + this.decimalPipe.transform(this.mockedData[i].amount, '1.0-0', 'hu-HU') + ' Ft';
        break;
      }
    }

    if(payFrequency.length > 0) {
      this.payfrequencyJunctureClick()
      this.newInsurantDataLocation.emit('payFrequency');
      this.newInsurantDataEvent.emit({paymentFrequency: payFrequency});
    }
  }

  payfrequencyJunctureClick() {
    this.DropdownFrame.junctureClick('conditionsJunctureFlag', 7);
  }
}
